import { lazy, Suspense } from 'react'
import AuthLayout from '../layouts/Auth'
import LoadingState from '../components/LoadingState'

const Unsubscribe = lazy(() => import('../pages/sms/Unsubscribe'))

const smsRoutes = [
  {
    path: '/sms/unsubscribe/:token',
    element: (
      <AuthLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <Unsubscribe />
        </Suspense>
      </AuthLayout>
    )
  }
]

export default smsRoutes
